import { set } from 'lodash'

export default (settings: Record<string, any>) => {
  if (!settings.linked_transactions?.list) return
  const linkedTransactions = settings.linked_transactions.list
  if (linkedTransactions.search !== undefined) {
    set(settings, ['linked-data', 'transactions', 'search'], linkedTransactions.search)
  }
  if (linkedTransactions.filter !== undefined) {
    set(settings, ['linked-data', 'transactions', 'filter'], linkedTransactions.filter)
  }
  if (linkedTransactions.sort !== undefined) {
    set(settings, ['linked-data', 'transactions', 'sort'], linkedTransactions.sort)
  }
  settings.linked_transactions = undefined
}
